import { jsx as _jsx } from "react/jsx-runtime";
export const ClickableArea = ({ children, className, style }) => {
    return (_jsx("div", { className: className, style: style, onClick: (e) => { e.stopPropagation(); }, children: children }));
};
